module.exports = __webpack_public_path__ + "static/media/greenChart.5b83820d.png";